import React from "react";
import { SingleShopHeroWrap } from "./SingleHero.styled";

const SingleHero = () => {
  return (
    <SingleShopHeroWrap>
      <div>
        <h2>Shop Single</h2>
      </div>
    </SingleShopHeroWrap>
  );
};

export default SingleHero;
